<template>
  <Fragment>
    <template v-if="$route.name !== 'endApplication'">
      <router-view></router-view>
    </template>
    <section class="container" v-else>
      <Breadcrumb />
      <div class="card-wrap mt-20 mb-20">
        <section class="card-content">
          <div class="left">
            <div class="search-name mr-15">
              <span>营销应用主题：</span>
              <el-input v-model="marketingName"> </el-input>
            </div>
            <div class="search-name mr-15">
              <span>品牌：</span>
              <el-select
                v-model="brandId"
                clearable
                placeholder="请选择"
                @change="getCategoryTypeOptions(brandId)"
              >
                <el-option
                  v-for="item in brandTypeOptions"
                  :key="item.brandId"
                  :label="item.brandName"
                  :value="item.brandId"
                >
                </el-option>
              </el-select>
            </div>
            <div class="search-name mr-15">
              <span>品类：</span>
              <el-select v-model="brandTypeId" clearable placeholder="请选择">
                <el-option
                  v-for="item in categoryTypeOptions"
                  :key="item.brandId"
                  :label="item.brandName"
                  :value="item.brandId"
                >
                </el-option>
              </el-select>
            </div>
            <div class="search-name mr-15">
              <span>应用分类：</span>
              <el-select
                v-model="applicationCategoryId"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in applicationCategoryOptions"
                  :key="item.applicationCategoryId"
                  :label="item.applicationCategoryName"
                  :value="item.applicationCategoryId"
                >
                </el-option>
              </el-select>
            </div>
            <el-button
              type="primary"
              class="ml-20"
              @click="searchEndApplicationInfo"
              >查询</el-button
            >
            <el-button type="primary" class="mr-20" @click="exportMarketingEnd"
              >下载</el-button
            >
          </div>
        </section>
      </div>
      <el-table :data="list" style="width: 100%" border>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            <span>{{ scope.$index + (pageNum - 1) * pageSize + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="营销应用主题" width="350">
          <template slot-scope="scope">
            <span>{{ scope.row.marketingName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          class="el-tooltip__popper"
          label="着陆地址"
          :fit="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.marketingUrl }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80">
          <span>{{ states }}</span>
        </el-table-column>
        <el-table-column label="工号" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.staffCode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="姓名" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.realName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="拍码数" width="80">
          <template slot-scope="scope">
            <span
              @click="marketingTimeInfo(scope.row)"
              style="color: #409EFF"
              >{{ scope.row.number }}</span
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20 pagination"
        background
        layout="total,prev, pager, next, jumper"
        :total="total"
        :page-size="10"
        :current-page="pageNum"
        @prev-click="handlePrePage"
        @next-click="handleNextPage"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </section>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";

import Breadcrumb from "@/components/Breadcrumb";

export default {
  name: "role",
  components: {
    Breadcrumb,
    Fragment
  },
  data() {
    return {
      marketingId: "",
      marketingName: "",
      number: "",
      brandId: "",
      applicationCategoryId: "",
      brandTypeId: "",
      brandTypeOptions: [],
      categoryTypeOptions: [],
      applicationCategoryOptions: [],
      list: [],
      states: "已结束",
      pageNum: 1,
      pageSize: 10,
      total: 0
    };
  },
  methods: {
    getEndApplicationList() {
      let _this = this;
      let param = {
        url: "/api/marketing/getMarketingList",
        params: {
          marketingName: _this.marketingName,
          brandId: _this.brandId,
          applicationCategoryId: _this.applicationCategoryId,
          brandTypeId: _this.brandTypeId,
          pageNum: _this.pageNum,
          pageSize: _this.pageSize
        }
      };

      _this.$store.dispatch("getEndApplicationList", param).then(() => {
        _this.list = _this.$store.state.marketingEnd.marketingEndList.list;
        _this.total = _this.$store.state.marketingEnd.marketingEndList.total;
        if (_this.list.length > 0) {
          for (var i = 0; i < _this.list.length; i++) {
            if (_this.list[i].number === null) {
              _this.list[i].number = 0;
              _this.number = _this.list[i].number;
            }
          }
        }
      });
    },
    //查询
    searchEndApplicationInfo() {
      let _this = this;
      _this.getEndApplicationList();
    },
    exportMarketingEnd() {
      let _this = this;
      let param = {
        marketingName: _this.marketingName,
        brandId: _this.brandId,
        applicationCategoryId: _this.applicationCategoryId,
        brandTypeId: _this.brandTypeId
      };
      _this.$Api
        .post("/api/marketing/exportMarketingEnd", param)
        .then(response => {
          if (response.status === 200) {
            _this.$Api.exportExcel(
              [
                "营销应用主题",
                "着陆地址",
                "状态",
                "拍码数",
                "品牌",
                "品类",
                "应用分类"
              ],
              [
                "marketingName",
                "marketingUrl",
                "states",
                "number",
                "brandName",
                "categoryName",
                "applicationCategoryName"
              ],
              response.data,
              "已终止的应用"
            );
          } else {
            _this.$message({
              message: "无法获取导出数据",
              type: "warning"
            });
          }
        });
    },
    //当前页
    handleCurrentChange(value) {
      let _this = this;
      _this.pageNum = value;
      _this.getEndApplicationList();
    },
    //上一页
    handlePrePage() {
      let _this = this;
      _this.pageNum -= 1;
      _this.getEndApplicationList();
    },
    //下一页
    handleNextPage() {
      let _this = this;
      _this.pageNum += 1;
      _this.getEndApplicationList();
    },
    //获取品牌下拉
    getBrandTypeOptions() {
      let _this = this;
      if (_this.brandId === "") {
        _this.brandIds = 0;
      }
      let param = {
        url: "/api/dictionaryBrand/getBrandTypeList",
        params: {
          brandId: _this.brandIds,
          pageNum: _this.brandPageNum,
          pageSize: _this.brandPageSize
        }
      };

      _this.$store.dispatch("getBrandTypeOptions", param).then(() => {
        _this.brandTypeOptions = _this.$store.state.brandType.brandTypeOptions;
      });
    },
    getCategoryTypeOptions(value) {
      let _this = this;
      let param = {
        url: "/api/dictionaryBrand/getBrandTypeList",
        params: {
          brandId: value,
          pageNum: _this.brandPageNum,
          pageSize: _this.brandPageSize
        }
      };

      _this.$store.dispatch("getBrandTypeOptions", param).then(() => {
        _this.categoryTypeOptions =
          _this.$store.state.brandType.brandTypeOptions;
      });
    },
    //获取应用分类下拉
    getApplicationCategoryOptions() {
      let _this = this;
      let param = {
        url: "/api/dictionaryCategory/getApplicationCategoryList",
        params: {
          pageNum: _this.brandPageNum,
          pageSize: _this.brandPageSize
        }
      };

      _this.$store.dispatch("getApplicationCategoryOptions", param).then(() => {
        _this.applicationCategoryOptions =
          _this.$store.state.dictionaries.applicationCategoryOptions;
      });
    },
    marketingTimeInfo(row) {
      this.$router.push({
        name: "marketingTimeInfo",
        params: {
          marketingId: row.marketingId,
          number: row.number,
          marketingName: row.marketingName
        }
      });
    }
  },
  created() {
    let _this = this;
    _this.getEndApplicationList();
    //加载品牌下拉
    _this.getBrandTypeOptions();
    //加载应用分类
    _this.getApplicationCategoryOptions();
  }
};
</script>

<style lang="sass" scoped>
.card-wrap
  .card-content
    display: flex
    align-items: center
    justify-content: space-between
    .left
      display: flex
    .el-button
      font-size: 14px
    .search-name, .search-code
      font-size: 14px
      display: flex
      align-items: center
      span
        white-space: nowrap
.pagination
  text-align: center
</style>
